module.exports = __webpack_public_path__ + "media/images/gobusiness_logo-23f1de0d5d890a0da65a48b2a914c67a.png";